export const APP_IS_INITIALIZED = "appInit/initialized"
export const appIsInitialized = () => ({ type: APP_IS_INITIALIZED })

export const INITIALIZE_APP = "appInit/initialize"
export const initializeApp = () => ({ type: INITIALIZE_APP })